<template>
  <div class="energy-parameters">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- 강의 생성 버튼 -->
      <button @click="handleCreateLecture" class="energy-card clickable-card">
        <div class="card-content">
          <svg class="card-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          <div class="card-title">강의 생성</div>
        </div>
      </button>

      <!-- 강의 참가 버튼 -->
      <button @click="handleJoinLecture" class="energy-card clickable-card">
        <div class="card-content">
          <svg class="card-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
          </svg>
          <div class="card-title">강의 참가</div>
        </div>
      </button>
    </div>
  </div>
</template>

<script setup>
defineProps({
  dataMode: {
    type: String,
    default: 'real-time'
  },
  selectedDevice: {
    type: String,
    default: 'all'
  }
})

// 이벤트 emit 정의
const emit = defineEmits(['create-lecture', 'join-lecture'])

// 클릭 핸들러 함수들
const handleCreateLecture = () => {
  emit('create-lecture')
}

const handleJoinLecture = () => {
  emit('join-lecture')
}
</script>

<style scoped>
.energy-parameters {
  @apply p-6;
}

.energy-card {
  @apply rounded-xl p-8 text-white shadow-lg w-full;
  background: linear-gradient(135deg, var(--sidebar), var(--sidebar), var(--sidebar-accent));
}

.clickable-card {
  @apply cursor-pointer transition-all duration-200 hover:scale-105 hover:shadow-xl;
}

.clickable-card:hover {
  background: linear-gradient(135deg, var(--sidebar-accent), var(--sidebar-accent), var(--sidebar));
}

.card-content {
  @apply flex flex-row items-center justify-center space-x-4;
}

.card-icon {
  @apply w-12 h-12;
}


.card-title {
  @apply text-xl font-semibold;
}
</style>

